import cn from 'classnames';
import type { FC } from 'react';
import React, { Suspense } from 'react';
import DocumentTitle from 'react-document-title';

import { useCountry } from '@lt/localization';
import { isShow as isShowCookieBanner } from 'src/components/Banners/utils';
import SubscribeMobileMountains from 'src/components/SubscribeMobileMountains';
import { useShowSubscribe } from 'src/components/SubscribeMobileMountains/hooks/useShowSubscribe';
import ProgressBar from '../../containers/ProgressBar';
import ViewedHotelsUpdater from '../../containers/ViewedHotelsUpdater';
import FloatingPanelMobile from '../FloatingPanelMobile';
import SearchPageDesktop from './desktop';
import SearchPageMobile from './mobile';

type SearchProps = {
  title: string;
  isMobile: boolean;
  isHotelOnly: boolean;
  mapView: boolean;
  countryName?: string;
  isWhitelabel?: boolean;
  isFirstResultsFetched: boolean;
  isEmptySearch: boolean;
  isEmptyFiltration: boolean;
  hideFilters: boolean;
  isSubscribeShown: boolean;
};

const Search: FC<SearchProps> = (props) => {
  const {
    title,
    isHotelOnly,
    isMobile,
    countryName,
    isWhitelabel,
    isFirstResultsFetched,
    isEmptySearch,
    isEmptyFiltration,
    hideFilters,
    isSubscribeShown,
    mapView,
  } = props;

  const searchTitle = `${title} | ${
    isHotelOnly ? 'Забронировать отель' : 'Купить тур'
  } онлайн`;

  const showResults =
    !mapView &&
    hideFilters &&
    !isSubscribeShown &&
    !isEmptySearch &&
    !isEmptyFiltration;

  const SearchPageComponent = isMobile ? SearchPageMobile : SearchPageDesktop;
  const showFloatingPanel =
    isMobile &&
    hideFilters &&
    ((isFirstResultsFetched && !isEmptySearch && !isSubscribeShown) ||
      isEmptyFiltration);
  const showMountains = !isWhitelabel && !isHotelOnly && showResults;

  const { isShow, handleCloseClick } = useShowSubscribe(!isShowCookieBanner());
  const { isRussia } = useCountry();

  return (
    <DocumentTitle title={searchTitle}>
      <div className={cn('search-page', { mobile: isMobile })}>
        <ProgressBar isMobile={isMobile} />
        <SearchPageComponent
          mapView={mapView}
          showResults={showResults}
          isEmptySearch={isEmptySearch}
        />
        {showFloatingPanel ? (
          <Suspense fallback={null}>
            <SubscribeMobileMountains
              countryName={countryName}
              isMountainsActive={isShow && showMountains && isRussia}
              onCloseMountains={handleCloseClick}
            >
              <FloatingPanelMobile
                isMountainsActive={isShow && showMountains && isRussia}
                onCloseMountains={handleCloseClick}
              />
            </SubscribeMobileMountains>
          </Suspense>
        ) : null}
        <ViewedHotelsUpdater />
      </div>
    </DocumentTitle>
  );
};

export default Search;
